(function () {
  'use strict';

  var STORAGE_KEY = 'tracked_cart_product_handles';

  // --- Helpers to work with localStorage ---

  function loadTrackedItems() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return [];
      var parsed = JSON.parse(raw);
      if (!Array.isArray(parsed)) return [];
      return parsed;
    } catch (e) {
      console.warn('[Cart Tracker] Failed to parse stored items', e);
      return [];
    }
  }

  function saveTrackedItems(items) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch (e) {
      console.warn('[Cart Tracker] Failed to save items', e);
    }
  }

  // --- Extract product handle helpers ---

  // Try to extract handle from an Ajax cart item object
  // Common fields:
  //   item.url -> "/products/handle?variant=123"
  //   item.handle (rare, but some setups add it)
  function getHandleFromAjaxItem(item) {
    if (!item || typeof item !== 'object') return null;

    if (item.handle) {
      return String(item.handle);
    }

    if (item.url && typeof item.url === 'string') {
      try {
        // Make sure it's an absolute URL so URL() can parse it
        var urlStr = item.url;
        if (urlStr.indexOf('http') !== 0) {
          urlStr = window.location.origin + urlStr;
        }
        var u = new URL(urlStr);
        // Expected path: /products/<handle> or /products/<handle>/...
        var segments = u.pathname.split('/').filter(Boolean); // remove empty
        var productsIndex = segments.indexOf('products');
        if (productsIndex !== -1 && segments[productsIndex + 1]) {
          return segments[productsIndex + 1];
        }
      } catch (e) {
        // Ignore parsing errors
      }
    }

    return null;
  }

  // Fallback: infer handle from current page URL if it's a product page
  function getHandleFromCurrentUrl() {
    try {
      var path = window.location.pathname || '';
      // Look for /products/<handle>
      var parts = path.split('/').filter(Boolean);
      var idx = parts.indexOf('products');
      if (idx !== -1 && parts[idx + 1]) {
        return parts[idx + 1];
      }
    } catch (e) {
      // Ignore
    }
    return null;
  }

  // --- Merge logic (we only track handle + quantity + timestamps) ---

  function mergeHandle(handle, quantity) {
    if (!handle || !quantity) return;

    var existing = loadTrackedItems();
    var now = new Date().toISOString();

    var idx = existing.findIndex(function (entry) {
      return String(entry.handle) === String(handle);
    });

    if (idx >= 0) {
      existing[idx].quantity += quantity;
      existing[idx].lastAddedAt = now;
    } else {
      existing.push({
        handle: String(handle),
        quantity: quantity,
        firstAddedAt: now,
        lastAddedAt: now
      });
    }

    saveTrackedItems(existing);
  }

  // Merge from Ajax "add.js" style response
  // Response may be a single item object or an array
  function mergeHandlesFromAjax(data) {
    if (!data) return;

    var items;
    // Some setups return the added line as a single object,
    // others as { items: [...] } or just an array.
    if (Array.isArray(data)) {
      items = data;
    } else if (Array.isArray(data.items)) {
      items = data.items;
    } else {
      items = [data];
    }

    items.forEach(function (item) {
      var handle = getHandleFromAjaxItem(item);
      var quantity = Number(item.quantity || 0) || 1;
      if (!handle) return;
      mergeHandle(handle, quantity);
    });
  }

  // Fallback: we only know quantity, get handle from URL
  function mergeHandleFromCurrentPage(quantity) {
    var handle = getHandleFromCurrentUrl();
    if (!handle) return;
    mergeHandle(handle, quantity);
  }

  // --- Hook into window.fetch ---

  if (window.fetch) {
    var originalFetch = window.fetch;
    window.fetch = function () {
      var args = arguments;

      return originalFetch.apply(this, args).then(function (response) {
        try {
          var url = (response && response.url) || (args[0] && args[0].url) || args[0];
          var method = (args[1] && (args[1].method || args[1].type)) || 'GET';
          method = String(method).toUpperCase();

          // Look for POST to /cart/add or /cart/add.js
          if (
            url &&
            typeof url === 'string' &&
            method === 'POST' &&
            (url.indexOf('/cart/add') !== -1 || url.indexOf('/cart/add.js') !== -1)
          ) {
            // Clone so we do not consume the body the theme needs
            var clone = response.clone();
            clone
              .json()
              .then(function (data) {
                mergeHandlesFromAjax(data);
              })
              .catch(function () {
                // Ignore JSON parse errors
              });
          }
        } catch (e) {
          console.warn('[Cart Tracker] fetch hook error', e);
        }

        return response;
      });
    };
  }

  // --- Hook into XMLHttpRequest ---

  if (window.XMLHttpRequest) {
    var OriginalXHR = window.XMLHttpRequest;

    function TrackingXHR() {
      var xhr = new OriginalXHR();
      var _open = xhr.open;
      var _send = xhr.send;

      var method = null;
      var url = null;

      xhr.open = function () {
        method = (arguments[0] || 'GET').toString().toUpperCase();
        url = arguments[1];
        return _open.apply(xhr, arguments);
      };

      xhr.send = function () {
        if (
          url &&
          typeof url === 'string' &&
          method === 'POST' &&
          (url.indexOf('/cart/add') !== -1 || url.indexOf('/cart/add.js') !== -1)
        ) {
          xhr.addEventListener('load', function () {
            try {
              var contentType = xhr.getResponseHeader('Content-Type') || '';
              if (contentType.indexOf('application/json') !== -1) {
                var data = JSON.parse(xhr.responseText);
                mergeHandlesFromAjax(data);
              }
            } catch (e) {
              console.warn('[Cart Tracker] XHR hook error', e);
            }
          });
        }
        return _send.apply(xhr, arguments);
      };

      return xhr;
    }

    window.XMLHttpRequest = TrackingXHR;
  }

  // --- Fallback: track standard form POSTs to /cart/add ---

  document.addEventListener(
    'submit',
    function (event) {
      try {
        var form = event.target;
        if (!(form instanceof HTMLFormElement)) return;

        var action = form.getAttribute('action') || '';
        if (action.indexOf('/cart/add') === -1) return;

        var qtyInput = form.querySelector('input[name="quantity"]');
        var quantity = qtyInput && qtyInput.value ? parseInt(qtyInput.value, 10) : 1;
        if (!quantity || isNaN(quantity)) quantity = 1;

        // We don't know the handle from the form fields,
        // so infer it from the current page URL (product page).
        mergeHandleFromCurrentPage(quantity);
      } catch (e) {
        console.warn('[Cart Tracker] submit listener error', e);
      }
    },
    true // capture phase
  );
})();
